import React from 'react';
import styles from './Footer.module.css';

import stampIcon from '../../assets/images/stamp.svg';
import consultIcon from '../../assets/images/consult_p.svg';
import qrCodeImg from '../../assets/images/qr_code.png';

const Footer = () => {
    return (
        <footer className={styles.footerRoot}>

            {/* 1. Верхняя секция */}
            <div className={styles.topSectionWrapper}>
                <div className={styles.topContainer}>
                    {/* Штамп (слева) */}
                    <div className={styles.stampWrapper}>
                        <img
                            src={stampIcon}
                            alt="Лицензия штамп"
                        />
                    </div>

                    <div className={styles.licenseText}>
                        Лицензия № ЛО35-01219 -10/00227881 от 13.05.2019 г. <br />
                        Министерства образования Республики Карелия
                    </div>
                </div>
            </div>

            {/* 2. Нижняя секция */}
            <div className={styles.bottomSectionWrapper}>
                <div className={styles.bottomContainer}>

                    {/* Иконка (в круге) */}
                    <div className={styles.iconWrapper}>
                        <img
                            src={consultIcon}
                            alt="Иконка консультации"
                        />
                    </div>

                    {/* Основной текст */}
                    <div className={styles.mainText}>
                        РАЗРАБАТЫВАЕМ ПРОГРАММЫ ДОПОЛНИТЕЛЬНОГО ОБРАЗОВАНИЯ
                        И ПРОФЕССИОНАЛЬНОГО ОБУЧЕНИЯ ПО ТЕХНИЧЕСКОМУ
                        ЗАДАНИЮ ЗАКАЗЧИКА
                    </div>

                    {/* QR код */}
                    <div className={styles.qrWrapper}>
                        <div className={styles.qrSvgContainer}>
                            <img
                                src={qrCodeImg}
                                alt="QR Code"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </footer>
    );
};

export default Footer;